var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhotoCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.411 50"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".photo-camera_svg__cls-1{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "photo-camera_svg__photo-camera",
    transform: "translate(0 -25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "photo-camera_svg__Group_16329",
    transform: "translate(0 25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "photo-camera_svg__Group_16328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "photo-camera_svg__Path_10430",
    d: "M53.247 57.684a2.164 2.164 0 002.165-2.165V41.45a8.668 8.668 0 00-8.658-8.658h-3.287a2.164 2.164 0 01-2.049-1.467l-.655-1.925a6.492 6.492 0 00-6.147-4.4H20.788a6.511 6.511 0 00-6.107 4.288l-.749 2.075a2.17 2.17 0 01-2.032 1.429H8.658A8.668 8.668 0 000 41.45v24.892A8.668 8.668 0 008.658 75h38.1a8.668 8.668 0 008.658-8.658 2.165 2.165 0 10-4.329 0 4.334 4.334 0 01-4.329 4.329h-38.1a4.334 4.334 0 01-4.329-4.329V41.45a4.334 4.334 0 014.329-4.329H11.9a6.511 6.511 0 006.1-4.288l.749-2.075a2.17 2.17 0 012.036-1.429h13.831a2.164 2.164 0 012.049 1.471l.655 1.924a6.492 6.492 0 006.147 4.4h3.286a4.334 4.334 0 014.329 4.329v14.066a2.164 2.164 0 002.165 2.165z",
    className: "photo-camera_svg__cls-1",
    transform: "translate(0 -25)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "photo-camera_svg__Group_16331",
    transform: "translate(14.286 39.286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "photo-camera_svg__Group_16330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "photo-camera_svg__Path_10431",
    d: "M145.528 157a13.528 13.528 0 1013.528 13.528A13.543 13.543 0 00145.528 157zm0 22.727a9.2 9.2 0 119.2-9.2 9.21 9.21 0 01-9.2 9.2z",
    className: "photo-camera_svg__cls-1",
    transform: "translate(-132 -157)"
  }))))));
}

export default SvgPhotoCamera;